import { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

const CashSessionOpen = ({ show, onClose, onSubmit, cashRegister }) => {
  const [formData, setFormData] = useState({
    monto_inicial: '',
    nombre_cajero: '',
    observaciones: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.monto_inicial || parseFloat(formData.monto_inicial) < 0) {
      setError('The opening amount must be 0 or greater');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const result = await onSubmit({
        monto_inicial: parseFloat(formData.monto_inicial),
        nombre_cajero: formData.nombre_cajero || null,
        observaciones: formData.observaciones,
      });

      if (!result.success) {
        setError(result.message || 'Error opening the session');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error opening the session');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-door-open me-2"></i>
          Open Register
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          <div className="mb-3">
            <p className="mb-2">
              <strong>Register:</strong> {cashRegister?.nombre}
            </p>
            <p className="mb-0">
              <strong>Point of Sale:</strong> {cashRegister?.punto_venta?.nombre}
            </p>
          </div>

          <hr />

          <Form.Group className="mb-3">
            <Form.Label>
              Opening Cash Amount <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="monto_inicial"
              value={formData.monto_inicial}
              onChange={handleChange}
              placeholder="0.00"
              required
              autoFocus
            />
            <Form.Text className="text-muted">Amount of cash the register starts with</Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Cashier Name</Form.Label>
            <Form.Control
              type="text"
              name="nombre_cajero"
              value={formData.nombre_cajero}
              onChange={handleChange}
              placeholder="E.g.: Maria Garcia (optional)"
              maxLength={100}
            />
            <Form.Text className="text-muted">This name will appear on the sales receipt</Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
              placeholder="Notes about the opening (optional)"
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Opening...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle me-2"></i>
                Open Register
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CashSessionOpen;